import React from "react"
import Column from "@amzn/meridian/column";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import Heading from "@amzn/meridian/heading";
import Alert from "@amzn/meridian/alert";
import Text from "@amzn/meridian/text";


/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @param info
 * @param infoAlt
 * @return JSX.Element
 */
const PageHeader = ({head, headAlt, desc, descAlt, info, infoAlt}) => {
    return (
        <Column spacing={"300"}>
            <Heading level={2} type="h400" alignment="left">
                <FormattedMessage id={head} defaultMessage={headAlt}/>
            </Heading>
            <Text color={"secondary"} alignment={"left"}><FormattedMessage id={desc} defaultMessage={descAlt}/></Text>
            <Alert width={"75%"} type="informational" size="medium"><FormattedMessage id={info} defaultMessage={infoAlt}/></Alert>
        </Column>
    )
}

PageHeader.propTypes = {
    head: PropTypes.string,
    headAlt: PropTypes.string,
    desc: PropTypes.string,
    descAlt: PropTypes.string,
}

export default PageHeader;


// WEBPACK FOOTER //
// ./src/components/util/PageHeader.js